import { useState } from 'react'
import { stopViewAs, viewingAs, type ViewAs } from '../lib/viewAs'

/**
 * 176. The strip that says whose eyes you are looking through.
 *
 * Above EVERYTHING — the shell, the terms gate, the no-access page — because
 * the person being viewed may not have agreed the terms or may be suspended,
 * and an administrator looking at their screen must never be stuck in it. Not
 * dismissible, for the environment strip's reason: forgetting you are someone
 * else is the failure this exists to prevent.
 *
 * Amber, the ModeSwitch `preview` tone: you are looking at something other
 * than your own view and nothing you do here is different — indeed nothing you
 * do here is saved at all (the database refuses every write).
 */
export function ViewAsBanner({ view = viewingAs() }: { view?: ViewAs | null }) {
  const [busy, setBusy] = useState(false)
  if (!view) return null
  const until = untilLabel(view.expiresAt)
  return (
    <div className="envbanner viewasbanner" role="status" aria-live="polite">
      <span className="envbanner__tag">View as</span>
      <span className="envbanner__body">
        You are seeing the platform as <strong>{view.displayName || 'another person'}</strong>.
        Read-only: nothing you do here is saved{until ? `. Ends at ${until}` : ''}.
      </span>
      <button
        type="button"
        className="btn btn--sm viewasbanner__stop"
        disabled={busy}
        onClick={() => {
          setBusy(true)
          void stopViewAs()
        }}
      >
        {busy ? '…' : 'Stop viewing'}
      </button>
    </div>
  )
}

/** "14:35" in the viewer's own clock, or null for a missing/odd timestamp. */
export function untilLabel(iso: string): string | null {
  const t = Date.parse(iso)
  if (Number.isNaN(t)) return null
  return new Date(t).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' })
}
